// import useFeatureFlags from '@/composables/useFeatureFlags';
// import { createAPI as createFusionAuthAPI } from '@@/api/FusionAuth/index.js';
import { createAPI as createAuthServiceAPI } from '@/api/AuthService/index.js';
import type { Api } from '@@/types/Api';

export async function useApi(): Promise<Api> {
  //TODO: this is broken in non admin views, we need to fix this beforeintroduce fusion auth if is needed in a future
  // const route = useRoute();
  // const { userProfile } = useAuth();

  // let actorIdToUseForFeatureFlags;
  // const selectedOrgId = route.params.id; // i've clicked on a client from the org list
  // const apptegyAdminOrgId = userProfile.value?.client; // i.e. i've logged in as admin@admin and not yet selected a client
  // const guardiansPrimaryOrgId = userProfile.value?.accessible_clients?.[0]?.client?.id; // guardian has many orgs so lets use the first one

  // if (selectedOrgId) {
  //   actorIdToUseForFeatureFlags = selectedOrgId;
  // } else if (apptegyAdminOrgId) {
  //   actorIdToUseForFeatureFlags = apptegyAdminOrgId;
  // } else {
  //   actorIdToUseForFeatureFlags = guardiansPrimaryOrgId;
  // }
  // const featureFlags = await useFeatureFlags(actorIdToUseForFeatureFlags);

  // if (featureFlags.value?.fusion_auth_enabled) {
  //   return createFusionAuthAPI();
  // }
  return createAuthServiceAPI();
}
